import {HttpCli} from 'yichen_encrypt'
import PwdUtils from "@/js/utils/PwdUtils";
import {getToken} from "@/js/utils/CookieUtil";

// const local = 'http://192.168.3.7:8088/'
// const local = 'http://192.168.3.116:8088'
// const local = 'http://192.168.31.134:8080/'
// const local = 'http://192.168.3.28:8080/'
// const local = 'http://192.168.3.221:8088/'
// const local = 'http://192.168.3.2:8088/'
const local = 'https://trading.mlnkjt.com/gw/'
const remote = 'https://trading.mlnkjt.com/gw/'
const HOST = process.env.NODE_ENV === 'development' ? local : remote

export function getMainDomain() {
  const hostname = window.location.hostname
  const parts = hostname.split('.')
  if (parts.length < 3) return hostname
  return parts.slice(-3).join('.')
}

export const href = process.env.NODE_ENV === 'development' ? 'http://localhost:2032/console/#/dashboard?auth=' + PwdUtils.randomString(128) : `https://${getMainDomain()}/console/#/dashboard?auth=` + PwdUtils.randomString(128)

export const ApiConf = {
  VUE_APP_BASE_API: HOST,
  STATIC_URL: 'https://trading.mlnkjt.com/tear/'
}

export const signup=()=>{
  window.location.href = `https://${getMainDomain()}/console/#/${getToken()?'':'merchantSignup'}`
}

export const getImageUrl = (str) => {
  if (!str || str.startsWith('http') || str.startsWith('data:')) {
    return str
  }
  return HttpCli.getStaticUrl(str)
}
